import { FormatPrice } from "../../utils/constants";
import { Add, Comment, DeleteForever, Edit, More, PlusOne, Remove } from "@mui/icons-material";
import { FormLabel, IconButton, Input, Stack, styled, TextField } from '@mui/material';
import { red } from "@mui/material/colors";
import { useRef, useState } from "react";
import { CustomDialog } from "../modals/custom-dialog";


const ButtomMore = styled("button")(({theme})=>({
    background:theme.palette.primary.main,
    color:"white",
    border:"none",
    width:'30px',
    height:'30px',
    borderTopRightRadius:'6px',
    borderBottomRightRadius:'6px'

}));
const ButtomRemove = styled("button")(({theme})=>({
    background:theme.palette.primary.main,
    color:"white",
    border:"none",
    width:'30px',
    height:'30px',
    borderTopLeftRadius:'6px',
    borderBottomLeftRadius:'6px'

}));
const SpanResult = styled("span")(({theme})=>({
    background:theme.palette.primary.main,
    color:"white",
    border:"none",
    minWidth:'30px',
    height:'30px',
    textAlign:"center",
    justifyContent:"center",
    alignContent:"center"
   
}));
const ButtomWrapp = styled("div")({
 display:"flex",
 flexDirection:"row"
});
const CInput = styled("input")({
    fontSize:'15px',
    borderColor:"#bbbbbb",
    borderWidth:'1px',
    padding:'4px',
    borderRadius:'4px'
    
   });

   const CInputArea = styled("textarea")({
    fontSize:'15px',
    borderColor:"#bbbbbb",
    borderWidth:'1px',
    padding:'4px',
    borderRadius:'4px'
    
   });

let IntervalTmeout = null;
export const ButtomQantity = ({
    prod_nombre='',
    value=1,
    observaciones="",
    maxQantity,
    onChange=()=>{},
    onDelete=()=>{}
})=>{

    const [modalOption,setModalOption] = useState({
        isOpened:false,
        title:"",
        content:null,
        actions:[]
    });
    const refInputQantity  = useRef();
    const refInputObservaciones  = useRef();
    const OnInitInterval = (Sumvalue)=>{
        OnClearInterval();
        IntervalTmeout = setInterval(() => {
            const sumQantity = value+= Sumvalue;
            if ( sumQantity > 0 && sumQantity < maxQantity ){
                onChange(sumQantity);
            }else if( sumQantity > 0 && sumQantity > maxQantity ){
                onChange(maxQantity);
                OnClearInterval();
            } else if( sumQantity < 0 ){
                onChange(0);
                OnClearInterval();
            }else{

            }
           
        },500);
    }

    const OnChangeWithoutInterval = (Sumvalue)=>{
        OnClearInterval();
        const sumQantity = value+= Sumvalue;
        if ( sumQantity > 0 && sumQantity < maxQantity ){
            onChange(sumQantity);
        }else if( sumQantity > 0 && sumQantity > maxQantity ){
            onChange(maxQantity);
    
        } else if( sumQantity < 0 ){
            onChange(0);
          
        }else{

        }
    }

    const OnClearInterval = ()=>{
        clearInterval(IntervalTmeout);
    }
    const OnEditCustomValue  = ()=>{

        setTimeout(() => {
        setModalOption({
            isOpened:true,
            title:prod_nombre,
            content:<Stack direction={"column"} >
                        <FormLabel>Cantidad a solicitar</FormLabel>
                        <CInput ref={refInputQantity}  defaultValue={value}  type="number" />
                    </Stack>,
           actions:[
            {
                title:"cerrar",
                buttomProps:{
                    type:'button',
                    variant:"contained",
                    color:"secondary",
                    onClick:()=>{ setModalOption({}) },
                }
            },
            {
            title:"Guargar",
            buttomProps:{
                type:'button',
                variant:"contained",
                color:"primary",
                onClick:()=>{
                
                const newValue = refInputQantity.current.value;
                 onChange(newValue,"cantidad");
                 setModalOption({})
                },
            }
           }]

        });

       }, 500);
    }
    const OnEditObservaciones  = ()=>{
    
        setTimeout(() => {
        setModalOption({
            isOpened:true,
            title:prod_nombre,
            content:<Stack direction={"column"} >
                        <FormLabel>Observaciones</FormLabel>
                        <CInputArea ref={refInputObservaciones}  defaultValue={observaciones}  type="text" />
                    </Stack>,
           actions:[
            {
                title:"cerrar",
                buttomProps:{
                    type:'button',
                    variant:"contained",
                    color:"secondary",
                    onClick:()=>{ setModalOption({}) },
                }
            },
            {
            title:"Guargar",
            buttomProps:{
                type:'button',
                variant:"contained",
                color:"primary",
                onClick:()=>{
                
                const newValue = refInputObservaciones.current.value;

                 onChange(newValue,"observaciones");
                 setModalOption({})
                },
            }
           }]

        });

       }, 500);
    }

    return (
        <ButtomWrapp>

            <CustomDialog 
            {...modalOption}
            />

            <ButtomRemove
            type="button"
            onClick={e=>OnChangeWithoutInterval(-1)} 
            onMouseUp={OnClearInterval} 
            onMouseDown={e=>OnInitInterval(-10)} 
            onTouchStart={e=>OnInitInterval(-10)}
            onTouchCancel={OnClearInterval}
            onTouchEnd={OnClearInterval}
            ><Remove /></ButtomRemove>
            <SpanResult>{value}</SpanResult>
            <ButtomMore  
            type="button"
            onClick={e=>OnChangeWithoutInterval(1)}
            onMouseUp={OnClearInterval} 
            onMouseDown={e=>OnInitInterval(10)} 
            onTouchStart={e=>OnInitInterval(10)}
            onTouchCancel={OnClearInterval}
            onTouchEnd={OnClearInterval}
            ><Add /></ButtomMore>
            <IconButton onClick={OnEditCustomValue}  sx={{background:"gray",color:"white",width:'30px',height:'30px',marginLeft:'2px'}} > <Edit/> </IconButton>
            <IconButton type="button" onClick={onDelete} sx={{background:red[500],color:"white",width:'30px',height:'30px',marginLeft:'2px'}} > <DeleteForever /> </IconButton>
            <IconButton onClick={OnEditObservaciones}  sx={{background:"gray",color:"white",width:'30px',height:'30px',marginLeft:'2px'}} > <Comment/> </IconButton>
         
        </ButtomWrapp>
    )
}